/**
 * @generated SignedSource<<0cf0070e9473363edb1fedca578c4d1e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type IssueSearchType = "HYBRID" | "LEXICAL" | "SEMANTIC" | "%future added value";
import type { FragmentRefs, Result } from "relay-runtime";
export type ListItemsPaginated_results$data = {
  readonly id?: string;
  readonly search: Result<{
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: "Issue";
        readonly applyAssignees: {
          readonly " $fragmentSpreads": FragmentRefs<"ApplyAssigneesBulkActionIssueFragment">;
        } | null | undefined;
        readonly id: string;
        readonly issueRow: {
          readonly " $fragmentSpreads": FragmentRefs<"IssueRow">;
        } | null | undefined;
        readonly number: number;
        readonly repository: {
          readonly name: string;
          readonly owner: {
            readonly login: string;
          };
        };
      } | {
        readonly __typename: "PullRequest";
        readonly id: string;
        readonly number: number;
        readonly pullRequestRow: {
          readonly " $fragmentSpreads": FragmentRefs<"PullRequestRow">;
        } | null | undefined;
        readonly repository: {
          readonly name: string;
          readonly owner: {
            readonly login: string;
          };
        };
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null | undefined;
    } | null | undefined>;
    readonly issueCount: number;
    readonly issueSearchType: IssueSearchType | null | undefined;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
      readonly hasNextPage: boolean;
      readonly hasPreviousPage: boolean;
      readonly startCursor: string | null | undefined;
    };
  }, unknown>;
  readonly " $fragmentType": "ListItemsPaginated_results";
};
export type ListItemsPaginated_results$key = {
  readonly " $data"?: ListItemsPaginated_results$data;
  readonly " $fragmentSpreads": FragmentRefs<"ListItemsPaginated_results">;
};

import SearchPaginatedQuery_graphql from './SearchPaginatedQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "search",
  "value"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "login",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v4/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "owner",
      "plural": false,
      "selections": [
        (v5/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "kind": "Variable",
  "name": "labelPageSize",
  "variableName": "labelPageSize"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "fetchRepository"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "labelPageSize"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "query"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "showIssueFieldPills"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "skip"
    },
    {
      "defaultValue": "ISSUE_ADVANCED",
      "kind": "LocalArgument",
      "name": "type"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*:: as any*/),
        "stream": true
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*:: as any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": SearchPaginatedQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "ListItemsPaginated_results",
  "selections": [
    {
      "kind": "CatchField",
      "field": {
        "alias": "search",
        "args": [
          {
            "kind": "Variable",
            "name": "query",
            "variableName": "query"
          },
          {
            "kind": "Variable",
            "name": "skip",
            "variableName": "skip"
          },
          {
            "kind": "Variable",
            "name": "type",
            "variableName": "type"
          }
        ],
        "concreteType": "SearchResultItemConnection",
        "kind": "LinkedField",
        "name": "__Query_search_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "issueCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "issueSearchType",
            "storageKey": null
          },
          {
            "kind": "Stream",
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "alias": null,
                  "args": null,
                  "concreteType": "SearchResultItemEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v1/*:: as any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v2/*:: as any*/),
                            (v3/*:: as any*/),
                            (v6/*:: as any*/),
                            {
                              "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "args": [
                                      {
                                        "kind": "Variable",
                                        "name": "fetchRepository",
                                        "variableName": "fetchRepository"
                                      },
                                      (v7/*:: as any*/),
                                      {
                                        "kind": "Variable",
                                        "name": "showIssueFieldPills",
                                        "variableName": "showIssueFieldPills"
                                      }
                                    ],
                                    "kind": "FragmentSpread",
                                    "name": "IssueRow"
                                  }
                                ],
                                "type": "Issue",
                                "abstractKey": null
                              },
                              "kind": "AliasedInlineFragmentSpread",
                              "name": "issueRow"
                            },
                            {
                              "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "InlineDataFragmentSpread",
                                    "name": "ApplyAssigneesBulkActionIssueFragment",
                                    "selections": [
                                      (v2/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 10
                                          }
                                        ],
                                        "concreteType": "AssigneeConnection",
                                        "kind": "LinkedField",
                                        "name": "assignedActors",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "AssigneeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      (v1/*:: as any*/),
                                                      (v2/*:: as any*/),
                                                      (v5/*:: as any*/),
                                                      (v4/*:: as any*/),
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "profileResourcePath",
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": [
                                                          {
                                                            "kind": "Literal",
                                                            "name": "size",
                                                            "value": 64
                                                          }
                                                        ],
                                                        "kind": "ScalarField",
                                                        "name": "avatarUrl",
                                                        "storageKey": "avatarUrl(size:64)"
                                                      },
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "isCopilot",
                                                            "storageKey": null
                                                          },
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "isAgent",
                                                            "storageKey": null
                                                          },
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "displayName",
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "type": "Bot",
                                                        "abstractKey": null
                                                      }
                                                    ],
                                                    "type": "Actor",
                                                    "abstractKey": "__isActor"
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": "assignedActors(first:10)"
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Repository",
                                        "kind": "LinkedField",
                                        "name": "repository",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "databaseId",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isPrivate",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isArchived",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "args": null,
                                    "argumentDefinitions": []
                                  }
                                ],
                                "type": "Issue",
                                "abstractKey": null
                              },
                              "kind": "AliasedInlineFragmentSpread",
                              "name": "applyAssignees"
                            }
                          ],
                          "type": "Issue",
                          "abstractKey": null
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v2/*:: as any*/),
                            (v3/*:: as any*/),
                            (v6/*:: as any*/),
                            {
                              "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "args": [
                                      (v7/*:: as any*/)
                                    ],
                                    "kind": "FragmentSpread",
                                    "name": "PullRequestRow"
                                  }
                                ],
                                "type": "PullRequest",
                                "abstractKey": null
                              },
                              "kind": "AliasedInlineFragmentSpread",
                              "name": "pullRequestRow"
                            }
                          ],
                          "type": "PullRequest",
                          "abstractKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "cursor",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                "action": "THROW"
              }
            ]
          },
          {
            "kind": "Defer",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPreviousPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      },
      "to": "RESULT"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v2/*:: as any*/)
      ],
      "type": "Node",
      "abstractKey": "__isNode"
    }
  ],
  "type": "Searchable",
  "abstractKey": "__isSearchable"
};
})();

(node as any).hash = "dfa8402e028f34fcbb239ee099f99cd6";

export default node;
